import { render } from "./AudienceStatsSkeleton.vue?vue&type=template&id=2b34e28a&scoped=true"
import script from "./AudienceStatsSkeleton.vue?vue&type=script&lang=js"
export * from "./AudienceStatsSkeleton.vue?vue&type=script&lang=js"

import "./AudienceStatsSkeleton.vue?vue&type=style&index=0&id=2b34e28a&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b34e28a"]])

export default __exports__